import React from "react";
import SquareButton from "../../ui/SquareButton";
import EditIcon from "@material-ui/icons/Edit";

const EditButton = ({ onClick, tooltip }) => {
  return (
    <div title={tooltip}>
      <SquareButton onClick={onClick}>
        <EditIcon fontSize="small" />
      </SquareButton>
    </div>
  );
};

export default EditButton;
